const config = {
    // api_path: 'http://localhost:8080',
    api_path: 'https://api-money-management-app-f4fb43c34681.herokuapp.com',

    token_name: 'pos_token',
    headers: () => {
        return {
            headers: {
                'Authorization': ' Bearer ' + localStorage.getItem('pos_token')
            }
        }
    }
}

export default config

